/**
 * Widget alarmes : liste des alertes actives avec niveau de sévérité et lien vers l'historique.
 */
import { WidgetShell } from "./WidgetShell";

export type AlarmItem = {
  id: string;
  severity: "critical" | "warning";
  message: string;
  source: string;
  time: string;
};

export type AlarmsWidgetProps = {
  alarms?: AlarmItem[];
  totalCount?: number;
};

const DEFAULT_ALARMS: AlarmItem[] = [
  {
    id: "1",
    severity: "critical",
    message: "Dépassement du seuil maxi de température sonde T2",
    source: "Bâtiment 3",
    time: "20:38",
  },
  {
    id: "2",
    severity: "warning",
    message: "Humidité élevée détectée",
    source: "Bâtiment 1",
    time: "19:12",
  },
  {
    id: "3",
    severity: "warning",
    message: "Consommation d'eau anormale",
    source: "Bâtiment 4",
    time: "18:45",
  },
];

const severityLabel = {
  critical: { text: "Critique", className: "bg-red-100 text-red-600" },
  warning: { text: "Alerte", className: "bg-warning/20 text-warning" },
};

export const AlarmsWidget = ({
  alarms = DEFAULT_ALARMS,
  totalCount = 12,
}: AlarmsWidgetProps) => {
  return (
    <WidgetShell title="Alertes actives">
      <ul className="space-y-3">
        {alarms.map((alarm) => {
          const badge = severityLabel[alarm.severity];
          return (
            <li
              key={alarm.id}
              className="flex gap-2 pb-3 border-b border-grey-light last:border-0"
            >
              <span
                className={`text-xs font-medium px-2 py-0.5 rounded h-fit shrink-0 ${badge.className}`}
              >
                {badge.text}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-default-text leading-snug">
                  {alarm.message}
                </p>
                <p className="text-xs text-grey-medium mt-1">
                  {alarm.source} · {alarm.time}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
      <button
        type="button"
        className="text-sm text-secondary font-medium mt-2 hover:underline"
      >
        Voir toutes les alertes ({totalCount}) →
      </button>
    </WidgetShell>
  );
};
